import { useSnapshot } from 'valtio';
import ProfileStore from '../store/profiles';

export { default as createDefaultProfileAction } from '../actions/profiles-actions/create-default-profile-action';
export { default as fetchActiveProfileOverviewAction } from '../actions/profiles-actions/fetch-active-profile-overview-action';
export const usePoliciesStore = () => {
  return useSnapshot(ProfileStore);
};
